import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sortBy } from 'lodash';
import { Category, CategoryService } from '@lobos/library';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header-main',
  templateUrl: './header-main.component.html',
  styleUrls: ['./header-main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMainComponent {
  public headerBgLink = '/assets/images/header-bg_' + environment.api.branchKey + '.jpg';
  public logoLink = '/assets/images/logo_' + environment.api.branchKey + '.png';
  public catalogRootPath = environment.catalogRootPath;
  public catalogRootPathWithSlash = environment.catalogRootPath.endsWith('/')
    ? environment.catalogRootPath
    : `${environment.catalogRootPath}/`;
  public selectedCategoryPath = this.catalogRootPath;
  public topLevelCategories$: Observable<Category[]> = this.categoryService
    .getByParentUrlPath(this.catalogRootPathWithSlash)
    .pipe(map((categories) => sortBy(categories, 'lngItemId')));

  @Output() toggelMenu = new EventEmitter();

  constructor(private categoryService: CategoryService) {}

  trackByUrlPath(_index: number, category: Category): string {
    return category.sUrlPath;
  }
}
